import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};
const GET = "getproduct";
const GETPRODUCT = "getproductbysubcatid";
const GETSINGLEPRODUCT = "getsingleproduct";
const GETPRODUCTBYCATID = "getproductbycategoryid";
const ADDPRODUCT = "insertProduct";

export default {
  GetProduct(payload) {
    return Repository.get(transformRoute(GET), payload);
  },
  GetProductBySubcatId(payload) {
    return Repository.post(transformRoute(GETPRODUCT), payload);
  },
  GetSingleProduct(payload) {
    return Repository.post(transformRoute(GETSINGLEPRODUCT), payload);
  },
  GetProductByCategoryId(payload) {
    return Repository.post(transformRoute(GETPRODUCTBYCATID), payload);
  },
  AddProduct(payload) {
    return Repository.post(transformRoute(ADDPRODUCT), payload);
  },
};

const transformRoute = (route) => {
  return `/product/${route}`;
};
